import Vue from 'vue'

import {
  Button,
  Icon,
  Field,
  Popup,
  Picker,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Overlay,
  Dialog
} from 'vant'

Vue.use(Button)
Vue.use(Icon)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Overlay)
Vue.use(Dialog)
